const checkIfDomainOfDoubletick = () => {
  const origin = window.location.origin;
  return origin && (origin.includes('doubletick') || origin.includes('localhost'));
};

export default checkIfDomainOfDoubletick;
